import { cn } from '@/lib/utils';

// This is a list of all the material icons that are used in the project
const createIconSpan = (iconName: string, className?: string, label?: string) =>
  label ? (
    <span
      className={cn('notranslate material-symbols-sharp', className)}
      role="img"
      aria-label={label}
    >
      {iconName.toLowerCase()}
    </span>
  ) : (
    <span
      className={cn('notranslate material-symbols-sharp', className)}
      aria-hidden="true"
    >
      {iconName.toLowerCase()}
    </span>
  );

interface MaterialIconsProps {
  iconName: string;
  className?: string;
  label?: string;
}

export default function MaterialIcons({
  iconName,
  className,
  label,
}: MaterialIconsProps) {
  return createIconSpan(iconName, className, label);
}

export function sortAtoZAndRemoveDuplicates(arr: string[]) {
  const uniqueSortedArray = Array.from(new Set(arr)).sort();
  return uniqueSortedArray.join(',');
}

export const arr = [
  'acute',
  'menu',
  'code_blocks',
  'account_balance',
  'account_circle',
  'account_tree',
  'action_key',
  'language',
  'arrow_outward',
  'arrow_downward',
  'target',
  'integration_instructions',
  'task',
  'web_traffic',
  'dynamic_feed',
  'business_center',
  'settings',
  'security',
  'activity_zone',
  'add_shopping_cart',
  'adjust',
  'apps',
  'architecture',
  'arrow_split',
  'auto_awesome_motion',
  'auto_stories',
  'auto_transmission',
  'autorenew',
  'barcode_reader',
  'bia',
  'biotech',
  'bluetooth_searching',
  'bolt',
  'book_2',
  'book_3',
  'book_4',
  'browse_activity',
  'category_search',
  'chat',
  'chat_bubble',
  'cheer',
  'chevron_right',
  'chevron_left',
  'search',
  'cloud',
  'cognition',
  'arrow_forward',
  'arrow_back',
  'expand_less',
  'expand_more',
  'collections_bookmark',
  'computer',
  'conditions',
  'content_paste_search',
  'cycle',
  'data_exploration',
  'data_loss_prevention',
  'database',
  'database_search',
  'design_services',
  'device_unknown',
  'distance',
  'dns',
  'docs',
  'document_search',
  'edit_note',
  'ecg',
  'experiment',
  'explore',
  'explore_nearby',
  'explore_off',
  'export_dictionary',
  'fact_check',
  'check',
  'copy_all',
  'factory',
  'familiar_face_and_zone',
  'feature_search',
  'done',
  'filter_5',
  'filter_7',
  'filter_9_plus',
  'filter_alt',
  'filter_center_focus',
  'filter_none',
  'close',
  'keyboard_arrow_down',
  'flight_takeoff',
  'folder_open',
  'forum',
  'format_shapes',
  'g_translate',
  'globe_book',
  'groups',
  'home_repair_service',
  'home',
  'close',
  'image_search',
  'kid_star',
  'library_books',
  'line_end_diamond',
  'local_hospital',
  'local_library',
  'local_police',
  'lock',
  'note_stack',
  'package_2',
  'radar',
  'rocket',
  'link',
  'rocket_launch',
  'school',
  'sdk',
  'shopping_bag_speed',
  'signpost',
  'star',
  'star_shine',
  'transcribe',
  'tune',
  'verified',
  'verified_user',
  'view_timeline',
  'visibility',
  'visibility_off',
  'volunteer_activism',
  'webhook',
  'widgets',
  'approval_delegation',
  'automation',
  'auto_transmission',
  'book',
  'help_outline',
  'show_chart',
  'rocket_launch',
  'bolt',
  'star',
  'security',
  'account_balance_wallet',
  'verified',
  'language',
  'target',
  'integration_instructions',
  'trophy',
  'acute',
  'web_traffic',
  'account_tree',
  'task',
  'shopping_cart',
  'campaign',
  'bookmark_border',
  'storefront',
  'chat',
  'neurology',
  'calendar_today',
  'menu_book',
  'mail',
  'g_translate',
  'desktop_windows',
  'bid_landscape',
  'code_blocks',
  'emoji_objects',
  'volunteer_activism',
  'thumb_up',
  'thumb_down',
  'refresh',
  'source',
  'content_copy',
  'calculate',
  'school',
  'api',
  'book_2',
  'flight',
  'payments',
  'location_on',
  'favorite',
  'communities',
  'dynamic_feed',
  'code',
  'send',
  'feed',
  'display_settings',
  'cached',
  'build',
  'check_circle',
  'info',
  'cancel',
  'play_circle',
  'quiz',
  'assignment',
];
